export default "__VITE_ASSET__D6ga4ttP__"